import React, {useState} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {faHandPointer} from "@fortawesome/free-solid-svg-icons";
import {RootState} from "../../../../Store/Reducers";
import Address from "../../../../Models/Address";
import {ModalActions} from "../../../../Store/Modal/Slice";
import {ADDRESSES_LIST_MODAL} from "../../../../Store/Modal/Types";
import ModalFooterWithButtons from "../../ModalFooterWithButtonsComponent";
import AddressTableComponent from "./AddressTableComponent";

const AddressListModalComponent = () => {

  const { addressesListModal } = useSelector((state: RootState) => state.ModalReducer)
  const client = addressesListModal.data.client;

  const [addressSelected, setAddressSelected] = useState<Address|undefined>(undefined);

  const dispatch = useDispatch();

  const onClose = (address?: Address) => {
    dispatch(ModalActions.closeModal({
      modal: ADDRESSES_LIST_MODAL,
      result: address
    }))
  }

  return (
    <Modal isOpen={addressesListModal.open} size="xl" scrollable>
      <ModalHeader>DIRECCIONES</ModalHeader>
      <ModalBody>
        <AddressTableComponent
          client={client}
          selectable
          onClose={onClose}
          setAddressSelected={setAddressSelected}
        />
      </ModalBody>
      <ModalFooterWithButtons
        onSave={() => { onClose(addressSelected) }}
        onClose={() => onClose()}
        saveTitle="Seleccionar"
        saveIcon={faHandPointer}
        disabledSave={!addressSelected}
      />
    </Modal>
  );
};
export default AddressListModalComponent;
